import { NavigationGuardNext, Route } from 'vue-router';
import store from '@/store';

import {
  SIMULADO_REVISAO,
  SIMULADO_VESTIBULARES_ANTERIORES,
  SIMULADO_CURSOS,
  SIMULADO_EXP_FREE,
  SIMULADO_SAEB
} from '@/constant/Simulated';

import SimulationService from '@/services/Simulation/SimulationService';

import { LIST_PERMISSION } from '@/constant/ListPermission';
import { hasPermissionSimulated } from '@/share/Util/Permissions/simulated';
import { LIST_PLAN_ID } from '@/constant/PlansIDs';

import Permission from './index';

const simulationService = new SimulationService();

const PAGE_SIMULATED_RESULT = 'SimulatedResult';

async function getSimulationCategory(idCategory: number) {
  try {
    await simulationService.checkSimulated(idCategory);
  } catch (error) {
    console.error(error);
  }
}

export async function permissionSimulated(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  await getSimulationCategory(Number(to.params?.id));

  const isPlanFree = store.getters.profile?.plan?.planID === LIST_PLAN_ID.FREE;

  if (to.name === PAGE_SIMULATED_RESULT) next();

  const PermissionClass = new Permission();
  const simulationUrl = store.getters.simulatedTitleCover.url || '';
  
  if (simulationUrl.includes(SIMULADO_EXP_FREE) || isPlanFree) {
    next();

    return;
  }

  if (simulationUrl.includes(SIMULADO_VESTIBULARES_ANTERIORES)) {
    const hasPermission = PermissionClass.can(LIST_PERMISSION.SIMULATIONS_PREVIOUS);

    if (hasPermission || isPlanFree) next();
    return;
  }

  if (simulationUrl.includes(SIMULADO_REVISAO)) {
    const hasPermission = PermissionClass.can(LIST_PERMISSION.SIMULATIONS_EXCLUSIVEENEM);

    if (hasPermission || isPlanFree) next();
    return;
  }

  if (simulationUrl.includes(SIMULADO_CURSOS)) {

    const hasPermission = PermissionClass.can(LIST_PERMISSION.SIMULATIONS_COURSES);

    if (hasPermission || isPlanFree) next();
    return;
  }

  if (simulationUrl.includes(SIMULADO_SAEB)) {
    const hasPermission = PermissionClass.can(LIST_PERMISSION.BOOKS_DEGREE_SAEB);

    if (hasPermission || isPlanFree) next();
    return;
  }

  next({
    name: 'SimulationsList'
  });
}

export function permissionSimulator(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  const hasPermission = hasPermissionSimulated();

  const isPlanFree = store.getters.profile?.plan?.planID === LIST_PLAN_ID.FREE;

  if (hasPermission || isPlanFree) {
    next();
    return;
  }
  next({
    name: 'SimulationsList'
  });
  
}

export function permissionSimulatorWithFree(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  const PermissionClass = new Permission();

  const verifyPermission = PermissionClass.can(LIST_PERMISSION.SIMULATION);
  const isPlanFree = store.getters.profile?.plan?.planID === LIST_PLAN_ID.FREE;

  if (verifyPermission || isPlanFree) {
    next();
    return;
  }

  next({ name: 'Dashboard' }); 
}
